import { c as _c } from "react/compiler-runtime";
export default function Purpose(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path clipRule="evenodd" d="M48 8a1 1 0 0 1 1 1v12a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1zM88 48a1 1 0 0 1-1 1H75a1 1 0 1 1 0-2h12a1 1 0 0 1 1 1zM22 48a1 1 0 0 1-1 1H9a1 1 0 1 1 0-2h12a1 1 0 0 1 1 1zM48 88a1 1 0 0 1-1-1V75a1 1 0 1 1 2 0v12a1 1 0 0 1-1 1zM66.293 66.293a1 1 0 0 1 1.414 0l8.5 8.5a1 1 0 0 1-1.414 1.414l-8.5-8.5a1 1 0 0 1 0-1.414zM76.207 19.793a1 1 0 0 1 0 1.414l-8.5 8.5a1 1 0 0 1-1.414-1.414l8.5-8.5a1 1 0 0 1 1.414 0zM29.707 66.293a1 1 0 0 0-1.414 0l-8.5 8.5a1 1 0 0 0 1.414 1.414l8.5-8.5a1 1 0 0 0 0-1.414zM19.793 19.793a1 1 0 0 0 0 1.414l8.5 8.5a1 1 0 0 0 1.414-1.414l-8.5-8.5a1 1 0 0 0-1.414 0zM48 66c9.941 0 18-8.059 18-18s-8.059-18-18-18-18 8.059-18 18 8.059 18 18 18zm0 2c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20z" fill="currentColor" fillRule="evenodd" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg aria-hidden={true} className={className} fill="none" height="96" viewBox="0 0 96 96" width="96" xmlns="http://www.w3.org/2000/svg">{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}